import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { SubAccount as schema } from '@bingads-webui/hotel-odata-schemas';

import { HotelGridOptionsBase } from './hotel-grid-options-base';
import { gridOptionUtils } from '../hotel-center-service';

const jsdata = globalContext.require('campaignui/feature/hotel-center-js-data/index');
const { bingadsGridColumn } = globalContext.require('component/bingads-grid/shared/column');

export default class HotelSubAccountGridOptions extends HotelGridOptionsBase {
  constructor({
    view,
    gridName,
    dateFilterContainer,
    p$daterange,
    serverContext,
    preferenceService,
    filterService,
    viewport,
    customHeaderOffset,
    i18n,
  }) {
    const entitySet = gridOptionUtils.getEntitySetByName('subAccount');

    super({
      view,
      gridName,
      dateFilterContainer,
      schema,
      entitySet,
      serverContext,
      preferenceService,
      p$daterange,
      filterService,
      viewport,
      customHeaderOffset,
    });

    this.i18n = i18n;

    let allColumns = [];
    this.plugins.columnChooser.categories[0].options.unshift({
      key: 'Id',
      name: this.i18n.getString('HotelCenter_Overview_Grid_SubAccount_Id_Label'),
      selectOption: 'optional',
    });
    this.plugins.columnChooser.categories[0].options.push({
      key: 'HotelAssociationCount',
      name: this.i18n.getString('HotelCenter_Overview_Grid_SubAccount_Hotel_Association_Count_Label'),
      selectOption: 'optional',
    });
    this.plugins.columnChooser.categories[0].options.push({
      key: 'Status',
      name: this.i18n.getString('HotelCenter_Overview_Grid_SubAccount_Status_Label'),
      selectOption: 'optional',
    });
    allColumns = _.pluck(this.plugins.columnChooser.categories[0].options, 'key').concat(['Metrics', 'PPSPauseType']);

    this.plugins.columnChooser.selected = ['Name', 'Id', 'HotelAssociationCount', 'Bid', 'BidMultipliers', 'Clicks', 'Impressions', 'CTR', 'Spend', 'AverageCPC', 'AveragePosition'];
    this.plugins.columnChooser.locked = ['Name'];

    this.dataSource = _.defaults(this.dataSource, {
      resource: jsdata.SubAccount,
      entity: jsdata.SubAccount,
      query: {
        $select: allColumns.join(','),
      },
    });

    this.columns.unshift(bingadsGridColumn({
      name: 'HotelAssociationCount',
      title: this.i18n.getString('HotelCenter_Overview_Grid_SubAccount_Hotel_Association_Count_Label'),
      type: 'number',
      format: 'integer',
    }));

    this.columns.unshift(bingadsGridColumn({
      name: 'Id',
      title: this.i18n.getString('HotelCenter_Overview_Grid_SubAccount_Id_Label'),
      type: 'string',
    }));

    this.columns.unshift({
      name: 'Status',
      sortable: 'Status',
      title: this.i18n.getString('HotelCenter_Overview_Grid_SubAccount_Status_Label'),
      property: item => _.pick(item, 'Status', 'PPSPauseType'),
      template: local => (local.value.PPSPauseType === 'Paused' ? i18n.getString(_TL_('Paused')) : local.value.Status),
    });

    this.plugins.placeholder = {
      container: '.grid-noresult',
      text: this.i18n.getString('HotelCenter_Grid_NoFilteredRecords'),
    };
    this.selection = {
      enabled: false,
    };
  }
}
